import React, { useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import toast from 'react-hot-toast'
import { Changepassword } from "../../../services/backendServices";
import { validatePassword } from '../../../utils/validation';
const ChangePasswordModal = ({ show, onClose }) => {
    const [formData, setFormData] = useState({ current_password: '', new_password: '', confirm_new_password: '' });
    const [errors, setErrors] = useState({});
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    //handle change input
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setErrors({ ...errors, [e.target.name]: '' });
    }

    // Validates if password and confirm password match
    const passwordsMatch = (password, confirmPassword) => {
        return password === confirmPassword;
    };
    // Validation function
    const validateForm = () => {
        const newErrors = {};
        if (!validatePassword(formData?.current_password?.trim())) {
            newErrors.current_password = 'Current password must be at least 6 characters.';
        }
        if (!validatePassword(formData.new_password?.trim())) {
            newErrors.new_password = 'New password must be at least 6 characters.';
        }
        if (!passwordsMatch(formData.new_password?.trim(), formData.confirm_new_password?.trim())) {
            newErrors.confirm_new_password = "Passwords do not match.";
        }
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return false;
        }
        return true;
    };

    //Function for handle Sbmit
    const handleSubmit = (e) => {
        e.preventDefault();
        // If validation fails, stop execution
        if (!validateForm()) {
            return;
        }
        const payload = {
            old_password: formData?.current_password?.trim(),
            new_password: formData?.new_password?.trim()
        }
        ChangepasswordApiCall(payload);
    };
    // Function for change password api call
    const ChangepasswordApiCall = async (payload) => {
        setIsLoading(true);
        try {
            const res = await Changepassword(payload);
            if (res.status) {
                toast.success(res.msg);
                onClose();
            } else {
                toast.error(res.msg);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal show={show} animation={true} size="md" className="mt-5">
            <Modal.Header closeButton={!isLoading} onHide={!isLoading ? onClose : null} className="modal-header">
                <Modal.Title>Change Password</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <div className="row">
                        <Form.Group className="form-group mb-3">
                            <Form.Label>Current Password</Form.Label>
                            <div className="password-wrapper">
                                <Form.Control
                                    name="current_password"
                                    type={showCurrentPassword ? 'text' : 'password'}
                                    value={formData.current_password}
                                    onChange={handleChange}
                                    placeholder="Enter Current Password"
                                    disabled={isLoading}
                                    required
                                />
                                <div onClick={() => setShowCurrentPassword(!showCurrentPassword)} className="toggle-password cursor-pointer">
                                    <i className={`mdi ${showCurrentPassword ? "mdi-eye" : "mdi-eye-off"} text-muted`} ></i>

                                </div>
                            </div>
                            {errors.current_password && <small className="danger-text">{errors.current_password}</small>}
                        </Form.Group>
                        <Form.Group className="form-group mb-3">
                            <Form.Label>New Password</Form.Label>
                            <div className="password-wrapper">
                                <Form.Control
                                    name="new_password"
                                    type={showNewPassword ? 'text' : 'password'}
                                    value={formData.new_password}
                                    onChange={handleChange}
                                    placeholder="Enter New Password"
                                    disabled={isLoading}
                                    required
                                />
                                <div onClick={() => setShowNewPassword(!showNewPassword)} className="toggle-password">
                                    <i className={`mdi ${showNewPassword ? "mdi-eye" : "mdi-eye-off"} text-muted`} ></i>

                                </div>
                            </div>
                            {errors.new_password && <small className="danger-text">{errors.new_password}</small>}
                        </Form.Group>
                        <Form.Group className="form-group mb-3">
                            <Form.Label>Confirm New Password</Form.Label>
                            <div className="password-wrapper">
                                <Form.Control
                                    name="confirm_new_password"
                                    type={showConfirmNewPassword ? 'text' : 'password'}
                                    value={formData.confirm_new_password}
                                    onChange={handleChange}
                                    placeholder="Re-Enter New Password"
                                    disabled={isLoading}
                                    required
                                />
                                <div onClick={() => setShowConfirmNewPassword(!showConfirmNewPassword)} className="toggle-password cursor-pointer">
                                    <i className={`mdi ${showConfirmNewPassword ? "mdi-eye" : "mdi-eye-off"} text-muted`} ></i>

                                </div>
                            </div>
                            {errors.confirm_new_password && <small className="danger-text">{errors.confirm_new_password}</small>}
                        </Form.Group>
                        <div className="d-flex justify-content-end gap-3 mt-3">
                            <Button variant="secondary" className="px-2 py-1" onClick={onClose} disabled={isLoading}>
                                Cancel
                            </Button>
                            <Button variant="primary" className="px-2 py-1" type="submit" disabled={isLoading}>
                                {isLoading ? <i className="mdi mdi-loading mdi-spin"></i> : "Submit"}
                            </Button>
                        </div>
                    </div>

                </Form>

            </Modal.Body>

        </Modal >
    );
};

export default ChangePasswordModal;
